<template>
  <v-container fluid>
    <v-layout column>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card :loading="loading">
          <v-card-text>
            <v-row v-if="localConnectedUser">
              <v-col cols="12" sm="12">
                <v-text-field v-model="localConnectedUser.name" :rules="nameRules" label="Nom"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="localConnectedUser.email"
                  :rules="emailRules"
                  :disabled="true"
                  label="Email Address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-chip
                  dark
                  v-for="role in localConnectedUser.roles"
                  :key="role.id"
                  v-model="role.name"
                  :color="role.name === 'superadmin' ? 'red' : role.name === 'admin' ? 'orange' : 'green'"
                >
                  {{ role.name }}
                </v-chip>
              </v-col>
              <v-col sm="4" offset-sm="2">
                <v-btn color="orange lighten-2" dark>
                  <v-icon dark left>mdi-lock-reset</v-icon>
                  <a class="white--text link" href="/forgot-password">Changer le mot de passe</a>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" :loading="loading" @click.native="updateProfile">Sauvegarder</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-layout>
    <v-layout column>
      <v-card class="mt-5" :loading="loading">
        <v-card-title>Token personnelle</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-btn
                v-if="!isActiveToken"
                color="primary"
                :loading="loading"
                @click.native="upsertToken"
                >
                <span>Crées token</span>
              </v-btn>
              <v-btn
                v-if="isActiveToken"
                dark
                color="red"
                :loading="loading"
                @click.native="deleteToken"
                >
                <span>Supprimer token</span>
              </v-btn>
            </v-col>
            <v-col v-if="token">
              <p>{{ token }}</p>
              <p>Sauvegarder le token dans un endroit sûr, il ne sera pas affiché à nouveau.</p>
              <p>Le token est valide jusqu'à la suppression.</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
import ConnectedUser from "@/models/ConnectedUser"
import { cloneDeep } from "lodash"

export default {
  async mounted() {
    await this.getData()
    this.localConnectedUser = cloneDeep(this.connectedUser)
  },
  watch: {
    connectedUser: function (newConnectedUser) {
      this.localConnectedUser = cloneDeep(newConnectedUser)
    },
  },
  data() {
    return {
      loading: false,
      localConnectedUser: null,
      valid: true,
      name: "",
      nameRules: [(v) => !!v || "Champ obligatoire"],
      emailRules: [(v) => !!v || "E-mail est obligatoire", (v) => /.+@.+/.test(v) || "E-mail doit être valide"],
      token: null,
      isActiveToken: false,
    }
  },
  methods: {
    async getData() {
      await ConnectedUser.getSelfProfile()
      this.loading = false
      this.getActiveTokenStatus()
    },
    async updateProfile() {
      this.loading = true
      await ConnectedUser.updateProfile(this.localConnectedUser)
      this.loading = false
    },
    async upsertToken() {
      this.loading = true
      await axios
        .post("/api/v1/personal-token")
        .then((response) => {
          this.token = response.data.data
          this.isActiveToken = true
        })
        .catch((error) => {
          console.error(error)
        })
      this.loading = false
    },
    async getActiveTokenStatus() {
      this.loading = true
      await axios
        .get("/api/v1/personal-token")
        .then((response) => {
          this.isActiveToken = response.data?.data?.is_active
        })
        .catch((error) => {
          console.error(error)
        })
      this.loading = false
    },
    async deleteToken() {
      this.loading = true
      await axios
        .delete("/api/v1/personal-token")
        .then((response) => {
          this.token = null
        })
        .catch((error) => {
          console.error(error)
        })
      await this.getActiveTokenStatus()
      this.loading = false
    },
  },
  computed: {
    connectedUser: function () {
      let user = ConnectedUser.query().first()
      this.localConnectedUser = cloneDeep(user)
      return user
    },
    passwordConfirmationRule() {
      return () => this.localConnectedUser.password === this.confirmPassword || "Les mots de passe ne correspondent pas"
    },
  },
}
</script>
